import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetPartnerAccountContainerPolicyMutationVariables = Types.Exact<{
  event_account_id: Types.Scalars['ID'];
  offline_card_checkout_limit?: Types.InputMaybe<Types.Scalars['Int']>;
  return_deadline_days?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type SetPartnerAccountContainerPolicyMutation = { __typename?: 'Mutation', setPartnerAccountContainerPolicy: { __typename?: 'EventAccount', id: string, offline_card_checkout_limit?: number | null, return_deadline_days?: number | null } };


export const SetPartnerAccountContainerPolicyDocument = gql`
    mutation SetPartnerAccountContainerPolicy($event_account_id: ID!, $offline_card_checkout_limit: Int, $return_deadline_days: Int) {
  setPartnerAccountContainerPolicy(
    event_account_id: $event_account_id
    offline_card_checkout_limit: $offline_card_checkout_limit
    return_deadline_days: $return_deadline_days
  ) {
    id
    offline_card_checkout_limit
    return_deadline_days
  }
}
    `;
export type SetPartnerAccountContainerPolicyMutationFn = Apollo.MutationFunction<SetPartnerAccountContainerPolicyMutation, SetPartnerAccountContainerPolicyMutationVariables>;

/**
 * __useSetPartnerAccountContainerPolicyMutation__
 *
 * To run a mutation, you first call `useSetPartnerAccountContainerPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPartnerAccountContainerPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPartnerAccountContainerPolicyMutation, { data, loading, error }] = useSetPartnerAccountContainerPolicyMutation({
 *   variables: {
 *      event_account_id: // value for 'event_account_id'
 *      offline_card_checkout_limit: // value for 'offline_card_checkout_limit'
 *      return_deadline_days: // value for 'return_deadline_days'
 *   },
 * });
 */
export function useSetPartnerAccountContainerPolicyMutation(baseOptions?: Apollo.MutationHookOptions<SetPartnerAccountContainerPolicyMutation, SetPartnerAccountContainerPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPartnerAccountContainerPolicyMutation, SetPartnerAccountContainerPolicyMutationVariables>(SetPartnerAccountContainerPolicyDocument, options);
      }
export type SetPartnerAccountContainerPolicyMutationHookResult = ReturnType<typeof useSetPartnerAccountContainerPolicyMutation>;
export type SetPartnerAccountContainerPolicyMutationResult = Apollo.MutationResult<SetPartnerAccountContainerPolicyMutation>;
export type SetPartnerAccountContainerPolicyMutationOptions = Apollo.BaseMutationOptions<SetPartnerAccountContainerPolicyMutation, SetPartnerAccountContainerPolicyMutationVariables>;